import axios from "axios";
import { getItem, showErrorToast } from "../utils/Functions";
import { paths } from "../router/Constant";
/******************* 
@Purpose : Object containing paths for application
@Parameter : {}
@Author : INIC
******************/
class ApiRequestService {
  constructor(baseURL) {
    this.baseURL = process.env.REACT_APP_API_URL;
    this.axiosService = axios.create({
      baseURL,
      headers: {
        "content-type": "application/json",
        accept: "application/json",
        Authorization: getItem("accessToken"),
      },
    });

    this.axiosPutService = axios.create({
      baseURL: this.baseURL,
    });
  }

  isTokenExpired(error) {
    const message = error?.data?.message;
    // Only clear session on explicit token failures.
    // Do not logout on generic HTTP 401 / "Unauthorized" —
    // endpoints like getJobDetails can return those without a bad session.
    const isExpired =
      message === "INVALID_TOKEN" ||
      message === "Token expired." ||
      message === "jwt expired" ||
      message === "jwt malformed";

    if (isExpired) {
      showErrorToast(message || "Session expired. Please login again.");
      localStorage.clear();
      window.location.href = paths.login;
      return true;
    }
    return false;
  }

  getApi(path, headers = {}, params = {}) {
    let isAuthorized = getItem("accessToken") ? true : false;
    return new Promise((resolve, reject) => {
      this.axiosService
        .get(path, {
          headers: isAuthorized
            ? { ...headers, Authorization: getItem("accessToken") }
            : headers,
          params,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.status,
            data: res.data,
          });
        })
        .catch((error) => {
          if (this.isTokenExpired(error?.response)) {
            resolve({
              message: error?.response?.data?.message,
              status: error?.response?.data?.status,
            });
          } else {
            reject(error?.response?.data || error);
          }
        });
    });
  }

  postApi(path, apiData, headers = {}) {
    let isAuthorized = getItem("accessToken") ? true : false;
    return new Promise((resolve, reject) => {
      this.axiosService
        .post(path, apiData, {
          headers: isAuthorized
            ? { ...headers, Authorization: getItem("accessToken") }
            : headers,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.status,
            data: res.data,
          });
        })
        .catch((error) => {
          if (this.isTokenExpired(error?.response)) {
            resolve({
              message: error?.response?.data?.message,
              status: error?.response?.data?.status,
            });
          } else {
            reject(error?.response?.data || error);
          }
        });
    });
  }

  deleteApi(path, headers = {}, apiData = {}) {
    let isAuthorized = getItem("accessToken") ? true : false;
    return new Promise((resolve, reject) => {
      this.axiosService
        .delete(path, {
          headers: isAuthorized
            ? { ...headers, Authorization: getItem("accessToken") }
            : headers,
          apiData,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.status,
            data: res.data,
          });
        })
        .catch((error) => {
          if (this.isTokenExpired(error?.response)) {
            resolve({
              message: error?.response?.data?.message,
              status: error?.response?.data?.status,
            });
          } else {
            reject(error?.response?.data || error);
          }
        });
    });
  }

  putApi(path, apiData, headers = {}) {
    let isAuthorized = getItem("accessToken") ? true : false;
    return new Promise((resolve, reject) => {
      this.axiosService
        .put(path, apiData, {
          headers: isAuthorized
            ? { ...headers, Authorization: getItem("accessToken") }
            : headers,
        })
        .then((res) => {
          resolve({
            message: res.data.message,
            status: res.data.status,
            data: res.data,
          });
        })
        .catch((error) => {
          if (this.isTokenExpired(error?.response)) {
            resolve({
              message: error?.response?.data?.message,
              status: error?.response?.data?.status,
            });
          } else {
            reject(error?.response?.data || error);
          }
        });
    });
  }
}

export default new ApiRequestService();
